(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eo-chicken-jelly-test"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.eoReady) return;
    root.dataset.eoReady = '1';

    var btn = root.querySelector('[data-jelly-chill]');
    if (!btn) return; /* bowl switched off in the editor */

    var status = root.querySelector('[data-jelly-status]');
    var body = root.querySelector('[data-jelly-body]');
    var bowl = root.querySelector('[data-jelly-bowl]');

    btn.addEventListener('click', function () {
      var set = root.classList.toggle('eo-jelly--is-set');
      btn.textContent = set ? btn.dataset.labelWarm : btn.dataset.labelChill;
      if (status) status.textContent = set ? btn.dataset.statusSet : btn.dataset.statusWarm;
    });

    if (bowl && body) {
      bowl.addEventListener('click', function () {
        if (!root.classList.contains('eo-jelly--is-set')) return;
        body.classList.remove('eo-jelly__bowl-body--wobble');
        void body.getBoundingClientRect(); /* restart the animation */
        body.classList.add('eo-jelly__bowl-body--wobble');
      });
    }
  }

  function boot() { document.querySelectorAll('[data-eo-jelly]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-chickenpersonas"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.eoReady) return;
    root.dataset.eoReady = '1';

    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (tab, j) {
        var on = i === j;
        tab.setAttribute('aria-selected', on);
        tab.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length;
        var keys = { ArrowRight: (i + 1) % n, ArrowLeft: (i - 1 + n) % n, Home: 0, End: n - 1 };
        if (e.key in keys) {
          e.preventDefault();
          select(keys[e.key], true);
        }
      });
    });

    var first = Math.min(Math.max(parseInt(root.dataset.default, 10) || 1, 1), tabs.length) - 1;
    select(first);

    /* Theme editor: selecting a tab block opens it */
    root.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i > -1) select(i);
    });
  }

  function boot() { document.querySelectorAll('[data-eo-personas]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-chickenproduct-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Pack picker + "Read more" ---------- */
  function initPacks(root) {
    var cta = root.querySelector('[data-eo-cta]');
    var radios = root.querySelectorAll('input[data-pack]');

    function apply(radio) {
      if (!radio || !cta) return;
      if (radio.dataset.cta) cta.textContent = radio.dataset.cta;
      if (radio.dataset.href) cta.setAttribute('href', radio.dataset.href);
      /* lets a sticky add-to-cart bar follow the chosen pack */
      document.dispatchEvent(new CustomEvent('eo:pack-change', {
        detail: {
          price: radio.dataset.sprice,
          caption: radio.dataset.scaption,
          label: radio.dataset.cta,
          href: radio.dataset.href
        }
      }));
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { apply(radio); });
      if (radio.checked) apply(radio);
    });

    var desc = root.querySelector('[data-eo-more]');
    var toggle = desc && desc.querySelector('[data-more-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = desc.classList.toggle('eo-hero__desc--open');
        toggle.setAttribute('aria-expanded', open);
        toggle.textContent = open ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
      });
    }
  }

  /* ---------- Gallery: main viewer + thumbnails ---------- */
  function initGallery(gal) {
    var track = gal.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var strip = gal.querySelector('[data-gallery-thumbs]');
    var thumbs = strip ? [].slice.call(strip.querySelectorAll('[data-gallery-thumb]')) : [];
    var current = 0;
    var target = null;
    var ticking = false;
    var clearTimer;

    /* play the active slide's video, pause the others */
    function media(i, on) {
      var slide = slides[i];
      if (!slide) return;
      var video = slide.querySelector('video');
      if (video) {
        if (on && video.hasAttribute('data-autoplay')) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        if (!on) video.pause();
      }
      var frame = slide.querySelector('iframe');
      if (frame && !on && frame.contentWindow) {
        try {
          frame.contentWindow.postMessage(
            frame.dataset.provider === 'vimeo'
              ? '{"method":"pause"}'
              : '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        } catch (e) {}
      }
    }

    function setActive(i) {
      if (i !== current) media(current, false);
      current = i;
      media(current, true);
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var thumb = thumbs[i];
      if (thumb && strip && strip.scrollWidth > strip.clientWidth + 1) {
        strip.scrollTo({
          left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    }

    function go(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      target = i;
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () { target = null; }, 900);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
      setActive(i);
    }

    /* swipe: follow the scroll position */
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (target !== null) {
          if (i === target) target = null;
          return;
        }
        if (i !== current) setActive(i);
      });
    }, { passive: true });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
    });

    track.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: slides.length - 1 };
      if (e.key in keys) {
        e.preventDefault();
        go(keys[e.key]);
      }
    });

    /* keep the active slide aligned when the screen size changes */
    function resnap() { track.scrollTo({ left: slides[current].offsetLeft, behavior: 'auto' }); }
    if ('ResizeObserver' in window) new ResizeObserver(resnap).observe(track);
    else window.addEventListener('resize', resnap);

    /* Theme editor: selecting an "Extra image / video" block shows that slide */
    gal.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('[data-gallery-slide]');
      if (!slide) return;
      var i = slides.indexOf(slide);
      if (i > -1) go(i, true);
    });

    setActive(0);
  }

  function initHero(root) {
    if (root.dataset.eoReady) return;
    root.dataset.eoReady = '1';
    initPacks(root);
    var gal = root.querySelector('[data-gallery]');
    if (gal) initGallery(gal);
  }

  function boot() {
    document.querySelectorAll('[data-eo-hero]').forEach(initHero);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  /* Any link with data-eo-pick="2" (Personas, Offer) selects that pack in the hero */
  if (!window.eoPickBound) {
    window.eoPickBound = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-eo-pick]');
      if (!link) return;
      var hero = document.querySelector('[data-eo-hero]');
      if (!hero) return;
      var radio = hero.querySelectorAll('input[data-pack]')[parseInt(link.dataset.eoPick, 10) - 1];
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-chickenprotein-math"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.eoReady) return;
    root.dataset.eoReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) return;

    root.classList.add('eo-protein--animate');
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        root.classList.add('eo-protein--in');
        io.disconnect();
      }
    }, { threshold: .25 });
    io.observe(root);
  }

  function boot() { document.querySelectorAll('[data-eo-protein]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eo-chickenstudy"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var CIRC = 263.894; /* 2 * PI * 42 */

  function fill(root) {
    root.querySelectorAll('[data-ring]').forEach(function (ring) {
      var v = Math.min(Math.max(parseFloat(ring.dataset.ring) || 0, 0), 100);
      var arc = ring.querySelector('circle:last-of-type');
      if (arc) arc.style.strokeDashoffset = CIRC * (1 - v / 100);
    });
  }

  function init(root) {
    if (root.dataset.eoReady) return;
    root.dataset.eoReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* animate when the section scrolls into view */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          fill(root);
          io.disconnect();
        }
      }, { threshold: .3 });
      io.observe(root);
    } else {
      fill(root);
    }
  }

  function boot() { document.querySelectorAll('[data-eo-study]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // this.variantSelector = document.getElementById("shopify-section-template--26961703403806__earthy_broth_switcher_BVf9gd");
      const child = document.querySelector('[data-broth-switcher]');
      this.variantSelector = child ? child.parentElement : null;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      if (this.variantSelector) {
        this.variantSelector.style.top = "0px";
      }
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.querySelector(".header__heading")?.classList.add('hide-after');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if (this.variantSelector) {
        this.variantSelector.style.top = "0px";
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.querySelector(".header__heading")?.classList.remove('hide-after');
      if (this.variantSelector) {
        const isMobile = window.matchMedia('(max-width: 990px)').matches;
        this.variantSelector.style.top = isMobile ? "75px" : "85px";
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
